// extracted by mini-css-extract-plugin
module.exports = {"start_doc":"StartDoc_start_doc__3Qm-v","h2":"StartDoc_h2__ekXzl"};